/** ຊ່ວງວັນທີ່ເດືອນປະຕິທິນ local — ອິງ date ຂອງ session / booking */

export function monthBoundsYyyyMm(
  year: number,
  month: number,
): { dateFrom: string; dateTo: string } {
  if (
    !Number.isInteger(year) ||
    !Number.isInteger(month) ||
    month < 1 ||
    month > 12
  ) {
    throw new Error("Invalid year or month");
  }
  const pad = (n: number) => String(n).padStart(2, "0");
  const dateFrom = `${year}-${pad(month)}-01`;
  const last = new Date(year, month, 0);
  const dateTo = `${year}-${pad(month)}-${pad(last.getDate())}`;
  return { dateFrom, dateTo };
}

export type ReportPeriodBound = {
  period: string;
  dateFromStart: string;
  dateToEnd: string;
};

/** ລາຍການຊ່ວງ period ສຳລັບ trend (day = ວັນທີ, month = yyyy-MM-01) */
export function listReportPeriodBounds(
  dateFrom: string,
  dateTo: string,
  groupBy: "day" | "month",
): ReportPeriodBound[] {
  const result: ReportPeriodBound[] = [];

  if (groupBy === "day") {
    const cursor = new Date(`${dateFrom}T12:00:00`);
    const end = new Date(`${dateTo}T12:00:00`);
    while (cursor <= end) {
      const period = cursor.toISOString().slice(0, 10);
      result.push({
        period,
        dateFromStart: `${period}T00:00:00`,
        dateToEnd: `${period}T23:59:59`,
      });
      cursor.setDate(cursor.getDate() + 1);
    }
    return result;
  }

  let year = Number.parseInt(dateFrom.slice(0, 4), 10);
  let month = Number.parseInt(dateFrom.slice(5, 7), 10);
  const endYear = Number.parseInt(dateTo.slice(0, 4), 10);
  const endMonth = Number.parseInt(dateTo.slice(5, 7), 10);

  while (year < endYear || (year === endYear && month <= endMonth)) {
    const bounds = monthBoundsYyyyMm(year, month);
    const period = bounds.dateFrom;
    const clippedFrom = bounds.dateFrom < dateFrom ? dateFrom : bounds.dateFrom;
    const clippedTo = bounds.dateTo > dateTo ? dateTo : bounds.dateTo;
    result.push({
      period,
      dateFromStart: `${clippedFrom}T00:00:00`,
      dateToEnd: `${clippedTo}T23:59:59`,
    });
    month += 1;
    if (month > 12) {
      month = 1;
      year += 1;
    }
  }

  return result;
}
